import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'rk-unsaved-changes-dialog',
    templateUrl: './unsaved-changes-dialog.component.html',
    styleUrl: './unsaved-changes-dialog.component.scss',
    standalone: false
})
export class UnsavedChangesDialogComponent {
  constructor(public dialogRef: MatDialogRef<UnsavedChangesDialogComponent>) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}
